import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	takeOnCall: {
		id: 'eoc-schedule.ui.list.schedule.controls.take-on-call',
		defaultMessage: 'Take on-call',
		description: 'Take on-call button.',
	},
	addOverrideFor: {
		id: 'eoc-schedule.ui.list.schedule.controls.add-override-for',
		defaultMessage: 'Add override for schedule {scheduleName}',
		description: 'Label for Add override for schedule button.',
	},
	takeOnCallFor: {
		id: 'eoc-schedule.ui.list.schedule.controls.take-on-call-for',
		defaultMessage: 'Take on-call for schedule {scheduleName}',
		description: 'Label for Take on-call for schedule button.',
	},
});
